import {createStore} from 'vuex';
import type {RouteRecordRaw} from 'vue-router'
import {getLoginAccount, getMenuByLoginAccount} from '@/request/api/userCenter/userCenter';
import {IOriginalMenu} from '@/util/interface/api/route/route';
import {addRoute, arrayToTree, setRouter, OriginMenu} from '@/util/class/route/route';
import router from '@/router';
import { host } from '@/util/config';

import { addMenu } from '@/request/api/userCenter/permission'
import { pathType, showType } from '@/util/interface/route/route';


// @ts-ignore
let lang = new PLATFORM_LANG();
// @ts-ignore
const CONFIG = new PLATFORM_CONFIG();

console.log(lang)
export default createStore({
    state: {
        organization: '',
        accessToken: localStorage.getItem('AccessToken') || '',
        userInfo: null,  //用户信息
        // @ts-ignore
        config: Object.assign({}, CONFIG, {
            lang: lang.lang,
            host: host + CONFIG.host
        }),
        routeList: [] as Array<RouteRecordRaw>,
        menuList: [] as Array<RouteRecordRaw>,
        isGetInfo: false,
        routeOriginList: []
    },
    getters: {},
    mutations: {
        setOrganization(state, data) {
            state.organization = data
        },
        setAccessToken(state, data) {
            state.accessToken = data;
            localStorage.setItem('AccessToken', data)
        },
        setUserInfo(state, data) {
            state.userInfo = data
        },
        setRouteList(state, list: Array<RouteRecordRaw>) {
            state.routeList = list;
        },
        setMenuList(state, list: Array<RouteRecordRaw>) {
            state.menuList = list;
        },
        setIsGetInfo(state, data) {
            state.isGetInfo = data;
        },
        setRouteOriginList(state, list) {
            state.routeOriginList = list;
        }

    },
    actions: {
        async getMenu({commit, state}) {
            const list: IOriginalMenu[] = await getMenuByLoginAccount();

            const routeList: Array<RouteRecordRaw> = setRouter(arrayToTree(list.filter(t => t.pathType == pathType.mine), ''), '');
            const menuList: Array<RouteRecordRaw> = setRouter(arrayToTree(list.filter(t => t.showType == showType.menu), ''), '');
            commit('setRouteOriginList', list)
            commit('setRouteList', routeList);
            commit('setMenuList', menuList);
            addRoute(router, 'Home', routeList)
            return routeList
        },
        async getUserInfo({commit, state}) {
            const data = await getLoginAccount();
            commit('setUserInfo', data.userInfo)
            commit('setAccessToken', data.accessToken)
        }
    },
    modules: {}
})
